// useContextMenu.js
import { useState, useCallback, useEffect } from 'react';

export type RightClickMenuMouseEvent = {
    mouseX: number;
    mouseY: number;
};

export function useRightClickMenu() {
    const [rightClickMenu, setRightClickMenu] = useState<RightClickMenuMouseEvent | null>(null);

    const handleRightClickMenu = useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            event.preventDefault();
            if (rightClickMenu) return;
            setRightClickMenu({ mouseX: event.clientX, mouseY: event.clientY });
        },
        [rightClickMenu],
    );

    const rightClickMenuClose = useCallback(() => {
        setRightClickMenu(null);
    }, []);

    useEffect(() => {
        const handleClick = () => {
            if (rightClickMenu) setRightClickMenu(null);
        };

        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [rightClickMenu]);

    return { rightClickMenu, handleRightClickMenu, rightClickMenuClose };
}
